import Vue from 'vue'
import App from './App.vue'
import router from './routerconf'
import firebase from "firebase/app";
import 'firebase/firestore'
import axios from "axios";
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import firebaseApp from './firebaseInit'
Vue.use(VueToast)

Vue.prototype.$axios = axios;


firebaseApp.firestore();


Vue.config.productionTip = false

let app;

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount("#app");
  }
});
